import React from 'react';
import { Grid, Button, Dropdown } from 'semantic-ui-react';
import * as _ from 'lodash';
import Form from 'semantic-ui-react/dist/es/collections/Form/Form';
import classNames from 'classnames';
import { TitledCard } from 'Components';

const SelectFieldWithAddRemoveComponent = props => {
  const {
    items,
    dataSource,
    onChange,
    onAddClick,
    onDeleteClick,
    onMoveItemUp,
    onMoveItemDown,
    meta: { touched, error },
    required,
    disabled,
  } = props;
  const errorClassName = classNames('input--message', {
    'input--message-error': touched && error,
    'input--message-empty': !touched,
  });
  return (
    <Form.Field error={touched && error ? true : false} required={required}>
      <TitledCard title={'Warehouse(s)/Kitchen(s)'}>
        <Grid className="tight">
          {_.map(items, (item, index) => {
            return (
              <Grid.Row columns={2} key={index}>
                <Grid.Column>
                  <Dropdown
                    fluid
                    search
                    selection
                    onChange={onChange.bind(null, index)}
                    value={item.WarehouseSiteId}
                    options={dataSource}
                    disabled={disabled}
                  />
                </Grid.Column>
                <Grid.Column>
                  <Button
                    icon="plus"
                    disabled={item.key === null}
                    onClick={onAddClick}
                  />
                  <Button
                    icon="minus"
                    disabled={item.key === null}
                    onClick={onDeleteClick.bind(null, index)}
                  />
                  <Button
                    icon="angle up"
                    disabled={item.key === null || index === 0}
                    onClick={onMoveItemUp.bind(null, index)}
                  />
                  <Button
                    icon="angle down"
                    disabled={item.key === null || index === items.length - 1}
                    onClick={onMoveItemDown.bind(null, index)}
                  />
                </Grid.Column>
              </Grid.Row>
            );
          })}
          <Grid.Row columns={1}>
            <Grid.Column>
              <span className={errorClassName}>{error}</span>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </TitledCard>
    </Form.Field>
  );
};

export default SelectFieldWithAddRemoveComponent;



// WEBPACK FOOTER //
// ./src/components/selectFieldWithAddRemove/component/index.js